var graphqlErrorMessage = function graphqlErrorMessage(_ref) {
  var message = _ref.message;
  return message;
};
var requestError = function requestError(response, bodyText, message) {
  var error = new Error(message);
  error.name = "RequestError";
  error.response = response;
  error.statusCode = response.status;
  error.bodyText = bodyText;
  return error;
};
var parseError = function parseError(response, bodyText, message) {
  var error = new Error(message);
  error.name = "ParseError";
  error.response = response;
  error.statusCode = response.status;
  error.bodyText = bodyText;
  return error;
};
var queryError = function queryError(errors, queryData) {
  var error = new Error(errors.map(graphqlErrorMessage).join(", "));
  error.name = "QueryError";
  error.errors = errors;
  error.queryData = queryData;
  return error;
};
var missingVariableError = function missingVariableError(name) {
  var error = new Error("Variable '" + name + "' is missing.");
  error.name = "MissingVariableError";
  error.variableName = name;
  return error;
};

export { missingVariableError, parseError, queryError, requestError };
//# sourceMappingURL=error.js.map
